import React from 'react'
import { useTranslation } from 'react-i18next'

import banner from 'resources/images/servicesBanner.jpg'
import img1 from 'resources/images/insurance1.jpg'
import img2 from 'resources/images/kxRisk.jpg'
import img3 from 'resources/images/risk.jpg'

import img4 from 'resources/images/services.webp'
export default function OurServices() {
    const { t } = useTranslation()
    const list = [
        {
            img: img1,
            title: 'services.trade.desc',
            description: [
                'services.broking.specialise1',
                'services.broking.specialise2',
                'services.broking.specialise3',
                'services.broking.specialise4',
            ],
        },
        {
            img: img2,
            title: 'services.trade.desc2',
            description: [
                'services.consultancy.specialise1',
                'services.consultancy.specialise2',
                'services.consultancy.specialise3',
            ],
        },
        {
            img: img3,
            title: 'services.trade.desc3',
            description: [
                'services.insurance.specialise1',
                'services.insurance.specialise2',
                'services.insurance.specialise3',
                'services.insurance.specialise4',
            ],
        },
        // {
        //   img: img4,
        //   title: "services.services.description",
        //   description: [
        //     "services.services.specialise1",
        //     "services.services.specialise2",
        //     "services.services.specialise3",
        //   ],
        // },
    ]
    return (
        <div className='bg-white'>
            <div className='w-full aspect-video max-h-[400px]  relative'>
                <img src={banner} className='w-full h-full object-center object-cover' alt='' />
                <div className='absolute top-0 left-0 w-full h-full bg-[#00000080] opacity-60'></div>
                <h1 className='absolute z-20 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[#fff] text-[4.5vw] font-medium'>
                    {t('home.ourServices')}
                </h1>
            </div>
            <div className='pt-8 text-2xl text-center font-semibold bg-container md:text-3xl md:pt-12 lg:pt-15'>
                {t('services.trade.title')}
            </div>
            <div className='py-12 bg-container space-y-10 md:py-15 lg:py-24'>
                {list.map((item, index) => (
                    <div key={index} className='flex flex-col gap-6 md:flex-row lg:gap-10'>
                        <div className='w-full aspect-video mx-auto h-auto md:w-[200px] lg:w-[320px]'>
                            <img src={item.img} className='w-full h-full object-cover' alt='' />
                        </div>
                        <div className='flex-1 text-[#333333]'>
                            <p className=' whitespace-pre-wrap text-[20px] font-medium leading-[28px]'>
                                {t(item.title)}
                            </p>
                            {/* <h3 className="text-lg py-2 font-bold">
                {t("services.specialise")}
              </h3> */}
                            {/* <ul className="list-disc pt-4 pl-6 font-medium">
                {item.description.map((desc, index) => (
                  <li key={index}>{t(desc)}</li>
                ))}
              </ul> */}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
